import { useNavigate, useSearchParams } from 'react-router-dom';
import { useGetStudentCertificate } from '../../hooks/useGetStudentCertificate';
import toast from 'react-hot-toast';
import { Button, Flex, Spinner, Text } from "@radix-ui/themes";
import { useExportDocument } from '../../hooks/useExportDocument';
import { ref } from 'yup';

export const Certificate = () => {
    const [searchParams] = useSearchParams();
    const id = searchParams.get("Id");
    const type = searchParams.get("Type");
    const courseId = searchParams.get("CourseId");

    const {downloadOnly} = useExportDocument();
    const { isLoading, isError, isLoadingError, refetch, error } = useGetStudentCertificate({ id,type,courseId }, {
        enabled: !!id && !!type,
        refetchOnWindowFocus: false,
        retry: true,
        onSuccess: (data: any) => {
            const blob = new Blob([data], { type: 'application/pdf' });
            downloadOnly(blob, `Documento`);
        },
        onError: (error: any) => {
            toast.error("Não é possivel carregar o documento solicitado.");
        }
    });
    function handleClickDownloadAgain(event: any): void {
        refetch();
    }

    return <>
        <Flex justify='center' align='center'>
            {isLoading && <Spinner loading />}
            {isError && <Text>Erro ao carregar certificado</Text>}
            {isLoadingError && <Text>Erro ao carregar certificado</Text>}
            {!isLoading && !isError && !isLoadingError && (
                <div>
                    <Button
                        onClick={
                            handleClickDownloadAgain}
                        type="button"
                    >
                        Transferir
                    </Button>
                </div>
            )}
        </Flex>
    </>
}
